    <div class="client-detail" *ngIf="!loading; else spinner">
      <div class="page-header">
        <button mat-icon-button routerLink="/clients" aria-label="Назад">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="page-title" *ngIf="client">{{ client.last_name }} {{ client.first_name }}{{ client.middle_name ? ' ' + client.middle_name : '' }}</h1>
        <h1 class="page-title" *ngIf="!client">Клиент</h1>
      </div>

      <div *ngIf="client">
        <mat-card class="detail-card">
          <mat-card-content>
            <mat-list>
              <mat-list-item>
                <mat-icon matListItemIcon>person</mat-icon>
                <span matListItemTitle>ФИО</span>
                <app-copy-text
                  matListItemLine
                  [value]="client.last_name + ' ' + client.first_name + (client.middle_name ? ' ' + client.middle_name : '')">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>phone</mat-icon>
                <span matListItemTitle>Телефон</span>
                <app-copy-text
                  matListItemLine
                  [value]="client.phone">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item *ngIf="client.email">
                <mat-icon matListItemIcon>email</mat-icon>
                <span matListItemTitle>Email</span>
                <app-copy-text
                  matListItemLine
                  [value]="client.email">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item *ngIf="client.driver_license">
                <mat-icon matListItemIcon>badge</mat-icon>
                <span matListItemTitle>Номер ВУ</span>
                <app-copy-text
                  matListItemLine
                  [value]="client.driver_license">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item *ngIf="client.driver_license_date">
                <mat-icon matListItemIcon>event</mat-icon>
                <span matListItemTitle>Дата выдачи ВУ</span>
                <app-copy-text
                  matListItemLine
                  [value]="formatDate(client.driver_license_date)">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item *ngIf="client.passport_number">
                <mat-icon matListItemIcon>contact_page</mat-icon>
                <span matListItemTitle>Серия/номер паспорта</span>
                <app-copy-text
                  matListItemLine
                  [value]="client.passport_number">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item *ngIf="client.passport_issued_date">
                <mat-icon matListItemIcon>event</mat-icon>
                <span matListItemTitle>Дата выдачи паспорта</span>
                <app-copy-text
                  matListItemLine
                  [value]="formatDate(client.passport_issued_date)">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item *ngIf="client.passport_issued_by">
                <mat-icon matListItemIcon>account_balance</mat-icon>
                <span matListItemTitle>Кем выдан паспорт</span>
                <app-copy-text
                  matListItemLine
                  [value]="client.passport_issued_by">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item *ngIf="client.birth_date">
                <mat-icon matListItemIcon>cake</mat-icon>
                <span matListItemTitle>Дата рождения</span>
                <app-copy-text
                  matListItemLine
                  [value]="formatDate(client.birth_date)">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item *ngIf="client.address">
                <mat-icon matListItemIcon>home</mat-icon>
                <span matListItemTitle>Адрес</span>
                <app-copy-text
                  matListItemLine
                  [value]="client.address">
                </app-copy-text>
              </mat-list-item>
            </mat-list>

            <mat-divider *ngIf="client.notes"></mat-divider>
            <div *ngIf="client.notes" class="notes-section">
              <strong>Заметки:</strong>
              <p>{{ client.notes }}</p>
            </div>

            <mat-divider></mat-divider>
            <div class="meta-section">
              <span>Создан: {{ formatDateTime(client.created) }}</span>
              <span>Изменён: {{ formatDateTime(client.modified) }}</span>
            </div>
          </mat-card-content>
        </mat-card>

        <div class="actions">
          <button mat-raised-button color="primary" class="full-width-btn"
                  [routerLink]="['/clients', client.id, 'edit']">
            <mat-icon>edit</mat-icon> Редактировать
          </button>
        </div>
      </div>
    </div>

    <ng-template #spinner>
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    </ng-template>
